import React from 'react';
import { get } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { StateEntities, StatesModel } from 'client/data/models/states';
import { UNITED_STATES_LIST } from 'client/data/constants/united-states-list';
import { LinkWidget } from 'site-modules/shared/components/link-widget/link-widget';
import { NATIONAL_LEASE_DEALS_PAGE_URL } from 'site-modules/lease-deals/constants/lease-deals-constants';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';

function LeaseDealsLinkWidgetUI({ unitedStates }) {
  if (!unitedStates) {
    return null;
  }

  const linkWidgets = [
    {
      links: UNITED_STATES_LIST.sort((a, b) => a.localeCompare(b, { sensitivity: 'base' }))
        .map(stateSlug => {
          const stateName = get(
            unitedStates.find(({ name }) => makeNiceName(name) === stateSlug),
            'name'
          );
          return {
            anchorText: stateName ? `Best lease deals in ${stateName}` : '',
            href: `${NATIONAL_LEASE_DEALS_PAGE_URL}${stateSlug}/`,
          };
        })
        .filter(({ anchorText }) => anchorText),
    },
  ];

  return (
    <LinkWidget
      className={null}
      linkWidgets={linkWidgets}
      titleClassName="heading-3 mb-1_5"
      title="Best lease deals by state"
    />
  );
}

LeaseDealsLinkWidgetUI.propTypes = {
  unitedStates: StateEntities.States,
};

export const LeaseDealsLinkWidget = connectToModel(LeaseDealsLinkWidgetUI, {
  unitedStates: bindToPath('allStates', StatesModel),
});
